import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import data from "./ESGsel.json";

function ESGselCard({
  categoryId,
  highlightedCards,
  inputValues,
  handleInputChange,
}) {
  const [filteredQuestions, setFilteredQuestions] = useState([]);

  useEffect(() => {
    // LocalStorage에서 ESGtype 가져오기
    const ESGtype = parseInt(localStorage.getItem("ESGtype"), 10);

    // 필터링 조건
    const filtered = data.filter(
      (item) =>
        item.categoryId === categoryId &&
        (ESGtype < 40 || (ESGtype >= 40 && item.type_b)) // type_b 조건 추가
    );

    setFilteredQuestions(filtered);
  }, [categoryId]);

  return (
    <div>
      {filteredQuestions.map((question) => (
        <Card
          key={question.pk}
          style={{
            marginBottom: "15px",
            border: highlightedCards.includes(question.pk)
              ? "2px solid red"
              : "1px solid #ccc",
          }}
        >
          <Card.Body>
            <h5>{question.problem}</h5>
            {question.choices ? (
              question.choices.map((choice, index) => (
                <div
                  key={index}
                  style={{
                    cursor: "pointer", // 클릭 가능한 커서
                    padding: "5px", // 약간의 여백 추가
                    transition: "background-color 0.3s ease", // 부드러운 색 변화
                  }}
                  onClick={() => handleInputChange(question.pk, choice)} // 선택지 변경
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f0f0f0")
                  } // hover 효과
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  } // hover 해제
                >
                  <Form.Check
                    type="radio"
                    name={`question-${question.pk}`}
                    label={choice}
                    checked={inputValues[question.pk] === choice}
                    onChange={() => handleInputChange(question.pk, choice)} // 기본 클릭 동작 유지
                  />
                </div>
              ))
            ) : (
              <Form.Control
                type="text"
                value={inputValues[question.pk] || ""}
                onChange={(e) => handleInputChange(question.pk, e.target.value)}
              />
            )}
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}

export default ESGselCard;
